import React from 'react';

function TextField({ id, label, helper, error, ...props }) {
	const describedBy = [];
	if (helper) describedBy.push(`${id}-helper`);
	if (error) describedBy.push(`${id}-error`);
	return (
		<div className="field">
			<label htmlFor={id}>{label}</label>
			<input id={id} aria-describedby={describedBy.join(' ') || undefined} aria-invalid={Boolean(error)} {...props} />
			{helper && <p id={`${id}-helper`} className="helper">{helper}</p>}
			{error && <p id={`${id}-error`} className="helper" style={{ color: 'var(--danger)' }}>{error}</p>}
		</div>
	);
}

export default TextField;


